import {RecordForm} from '../forms/RecordForm';


import {useRatePlan} from '../hooks/useRatePlan.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";


export const AddPage = () => {

    const {
        record,
        createRecord,
    } = useRatePlan();

    return (
        <FormPageLayout
            title='Add Rate Plan'
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={record || {} as any} handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};
